import { render, staticRenderFns } from "./WidgetVisibilityConfig.vue?vue&type=template&id=84379584&"
import script from "./WidgetVisibilityConfig.vue?vue&type=script&lang=js&"
export * from "./WidgetVisibilityConfig.vue?vue&type=script&lang=js&"
import style0 from "./WidgetVisibilityConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports